import { dateFunc } from "@/components/Functions/dateFunc";
import { customComparator } from "@/utility/common";
import { useTranslation } from "react-i18next";

export const useColumnDistributionSteps = (processingData: any) => {
  const { t } = useTranslation();
  return [
    {
      field: "action",
      headerName: "",
      sortable: false,
      width: 150,
      cellRenderer: "sortingCellRenderers",
      cellRendererParams: {
        processingStatus: processingData,
      },
    },
    {
      field: "sortOrder",
      type: "sortOrderType",
      headerName: t(
        "pages.distributions.distributionStepsTab.columnDetails.column1"
      ),
      sortable: true,
      unSortIcon: true,
      cellRenderer: "orderCellRenderer",
      cellClass: "align-left",
      headerClass: "disableAgGridColumn",
    },
    {
      field: "name",
      type: "nameType",
      headerName: t(
        "pages.distributions.distributionStepsTab.columnDetails.column2"
      ),
      sortable: false,
      comparator: customComparator,
      unSortIcon: true,
      cellClass: "align-left",
      headerClass: "align-left",
      editable: true,
      cellRenderer: "stepNameRenderer",
      wordWrap: true,
      autoHeight: true,
    },
    {
      field: "subAccountName",
      type: "subAccountNameType",
      headerName: t(
        "pages.distributions.distributionStepsTab.columnDetails.column3"
      ),
      sortable: false,
      comparator: customComparator,
      unSortIcon: true,
      cellClass: "align-left",
      headerClass: "align-left",
      // cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: ["SubAccount 1", "SubAccount 2", "SubAccount 3"],
      },
      // editable: true,
      cellRenderer: "subAccountRenderer",
      // onCellClicked: ()=>setCurrentTab((DistributionsTab.AccountSetUp))
    },
    {
      field: "isMemo",
      type: "isMemoType",
      headerName: t(
        "pages.distributions.distributionStepsTab.columnDetails.column4"
      ),
      sortable: false,
      unSortIcon: true,
      cellClass: "align-left",
      headerClass: "align-left",
      cellRenderer: function (params: any) {
        return params.value ? "Memo" : "Payable";
      },
    },
    {
      field: "calculationGroupBy",
      type: "paymentGroupingType",
      headerName: t(
        "pages.distributions.distributionStepsTab.columnDetails.column5"
      ),
      sortable: false,
      comparator: customComparator,
      unSortIcon: true,
      cellClass: "align-left",
      headerClass: "align-left",
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: ["Creditors", "Claims", "Asignee/Creditor", "Case"],
      },
      cellRenderer: function (params: any) {
        switch (params.value) {
          case 0:
            return "Creditors";
          case 1:
            return "Claims";
          case 2:
            return "Assignee/Creditor";
          case 3:
            return "Case";
          default:
            return "";
        }
      },
      editable: true,
    },
    {
      field: "payeeTypeName",
      type: "payeeTypeNameType",
      headerName: t(
        "pages.distributions.distributionStepsTab.columnDetails.column6"
      ),
      sortable: false,
      unSortIcon: true,
      cellClass: "align-left",
      headerClass: "align-left",
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: ["Provincial tax authority (case level)", "Other Payee Type"],
      },
      editable: true,
      cellRenderer: "payeeTypeRenderer",
    },
    {
      field: "comment",
      type: "commentType",
      headerName: t(
        "pages.distributions.distributionStepsTab.columnDetails.column9"
      ),
      sortable: false,
      unSortIcon: true,
      cellClass: "align-left",
      headerClass: "align-left",
      autoHeight: true,
      wrapText: true,
    },
    {
      field: "updatedOn",
      type: "lastUpdatedDateType",
      headerName: t(
        "pages.distributions.distributionStepsTab.columnDetails.column7"
      ),
      sortable: false,
      unSortIcon: true,
      cellClass: "align-left",
      headerClass: "align-left",
      cellRenderer: function (params: any) {
        return dateFunc(params.value).formattedDateOnly;
      },
    },
    {
      field: "updatedBy",
      type: "updatedByType",
      headerName: t(
        "pages.distributions.distributionStepsTab.columnDetails.column8"
      ),
      sortable: false,
      unSortIcon: true,
      cellClass: "align-left",
      headerClass: "align-left",
    },
    {
      cellRenderer: "actionCellRenderers",
      field: "action",
      headerName: "",
      flex: 1,
      sortable: false,
    },
  ];
};
